import { IAppState } from '@myStore/app.state';
import { IProfileViewState } from '@myStore/profile-view/profile-view.state';
import { createSelector } from '@ngrx/store';

const profileViewSelector = (state: IAppState) => state.profileView;

export const selectProfile = createSelector(
  profileViewSelector,
  (state: IProfileViewState) => state?.data
);

export const selectProfileViewLoading = createSelector(
  profileViewSelector,
  (state: IProfileViewState) => state?.isLoading
);
